import http from "./http-common";
import axios from "axios";

const DataService = {
  logLogin: {
    create: (data) => http.post("/logLogin", data),
    update: (id, data) => http.post(`/logLogin/${id}`, data),
    getLastLoginToday: () => http.get("/logLogin/getLastLoginToday"),
    listBetweenDate: (startDate, endDate) =>
      http.get(`/logLogin/listBetweenDate/${startDate}/${endDate}`),
    getIp: () => axios.get("https://api.ipify.org?format=json"),
  },
  member: {
    get: (id) => http.get(`/member/${id}`),
    getByEmail: (email) => http.get(`/member/getByEmail?email=${email}`),
    getByID: (id) => http.get(`/member/getByID/${id}`),
    create: (data) => http.post("/member", data),
    update: (id, data) => http.post(`/member/${id}`, data),
    list: () => http.get("/member"),
    destroy: (id) => http.delete(`/member/${id}`),
    findlimit: (page, limit, search) =>
      http.get(`/member/findlimit`, { params: { page, limit, search } }),
  },
  permit: {
    create: (data) => http.post("/permit", data),
    update: (id, data) => http.post(`/permit/${id}`, data),
    findByPk: (id) => http.get(`/permit/findByPk/${id}`),
    destroy: (id) => http.delete(`/permit/${id}`),
  },

  product: {
    list: () => http.get("/product"),
    create: (data) => http.post("/product", data),
    update: (id, data) => http.post(`/product/${id}`, data),
    findByPk: (id) => http.get(`/product/findByPk/${id}`),
    destroy: (id) => http.delete(`/product/${id}`),
    findlimitcomplete: (page, limit, search) =>
      http.get(`/product/findlimitcomplete`, {
        params: { page, limit, search },
      }),
    findlimitincomplete: (page, limit, search) =>
      http.get(`/product/findlimitincomplete`, {
        params: { page, limit, search },
      }),
  },
  image: {
    create: (data) =>
      http.post("/image", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    update: (data) =>
      http.post("/image/update", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),

    findByProductId: (id) => http.get(`/image/findByProductId/${id}`),
    destroy: (id) => http.delete(`/image/${id}`),
  },

  imagecatalog: {
    create: (data) =>
      http.post("/imagecatalog", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    update: (data) =>
      http.post("/imagecatalog/update", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),

    findByProductId: (id) => http.get(`/imagecatalog/findByProductId/${id}`),
    destroy: (id) => http.delete(`/imagecatalog/${id}`),
  },
  
  banner: {
    create: (data) =>
      http.post("/promotion", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    update: (data) =>
      http.post("/promotion/update", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),

    findByProductId: (id) => http.get(`/promotion/findByProductId/${id}`),
    list: () => http.get("/promotion"),
    findlimit: (page, limit, search) =>
      http.get(`/promotion/findlimit`, { params: { page, limit, search } }),
  },
  customer: {
    list: () => http.get("/customer"),
    create: (data) => http.post("/customer", data),
    update: (id, data) => http.post(`/customer/${id}`, data),
    destroy: (id) => http.delete(`/customer/${id}`),
    findlimitcomplete: (page, limit, search) =>
      http.get(`/customer/findlimitcomplete`, {
        params: { page, limit, search },
      }),
    findlimitincomplete: (page, limit, search) =>
      http.get(`/customer/findlimitincomplete`, {
        params: { page, limit, search },
      }),
  },
  groupcustomer: {
    list: () => http.get("/groupcustomer"),
    create: (data) => http.post("/groupcustomer", data),
    update: (id, data) => http.post(`/groupcustomer/${id}`, data),
    destroy: (id) => http.delete(`/groupcustomer/${id}`),
    findlimit: (page, limit, search) =>
      http.get(`/groupcustomer/findlimit`, { params: { page, limit, search } }),
  },
  categories: {
    list: () => http.get("/categories"),
    create: (data) => http.post("/categories", data),
    update: (id, data) => http.post(`/categories/${id}`, data),
    destroy: (id) => http.delete(`/categories/${id}`),
    findlimit: (page, limit, search) =>
      http.get(`/categories/findlimit`, { params: { page, limit, search } }),
  },
  subcategories: {
    list: () => http.get("/subcategories"),
    create: (data) => http.post("/subcategories", data),
    update: (id, data) => http.post(`/subcategories/${id}`, data),
    destroy: (id) => http.delete(`/subcategories/${id}`),
    findlimit: (page, limit, search) =>
      http.get(`/subcategories/findlimit`, { params: { page, limit, search } }),
  },
  itemGroups: {
    list: () => http.get("/itemGroups"),
    create: (data) => http.post("/itemGroups", data),
    update: (id, data) => http.post(`/itemGroups/${id}`, data),
    destroy: (id) => http.delete(`/itemGroups/${id}`),
    findlimit: (page, limit, search) =>
      http.get(`/itemGroups/findlimit`, { params: { page, limit, search } }),
  },

  headerorders: {
    list: () => http.get("/headerorders"),
    create: (data) => http.post("/headerorders", data),
    update: (id, data) => http.post(`/headerorders/${id}`, data),
    findlimit: (page, limit, search) =>
      http.get(`/headerorders/findlimit`, { params: { page, limit, search } }),
    findlimitByID: (id, page, limit, search) =>
      http.get(`/headerorders/findlimitByID/${id}`, {
        params: { page, limit, search },
      }),
  },

  video: {
    create: (data) =>
      http.post("/video", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    update: (data) =>
      http.post("/video/update", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    findByProductId: (id) => http.get(`/video/findByProductId/${id}`),
    list: () => http.get("/video"),
    findlimit: (page, limit, search) =>
      http.get(`/video/findlimit`, { params: { page, limit, search } }),
  },

  apiemail: {
    verifyEmail: (data) => http.post("/apiemail/verify-email", data),
    changePassword: (data) => http.post("/apiemail/change-password", data),
  },

 catalog: {
    // เพิ่ม config parameter รองรับ responseType
    list: (data, config = {}) => http.post("/catalog/export-psd", data, config),
    proxyImage: (imageUrl, config = {}) => 
    http.get(`/catalog/proxy-image?url=${encodeURIComponent(imageUrl)}`, config),
  },

};

export { DataService };
